// Additional details field and the Save / Save and Propagate / Cancel actions.

import React from 'react';
import PropTypes from 'prop-types';
import Share from '@decisiv/iconix/lib/components/Share';
import { Button, Grid, TextArea } from '@decisiv/ui-components';
import { t, Trans } from '@lingui/macro';
import { H4 } from '@decisiv/ui-components/lib/components/Typography';
import Flex from '@decisiv/ui-components/lib/components/Flex';

import { labelFor, normalizeTextValue } from '../../features/dynamic-form';
import { FormGroup, SectionRow } from '../StyledComponents';

const ADDITIONAL_DETAILS_MAX_LENGTH = 500;

const FormFooter = ({
  additionalDetails = '',
  onAdditionalDetailsChange,
  readOnly,
  saveDisabled = false,
  propagateDisabled = false,
  canPropagate = false,
  onSave,
  onSaveAndPropagate,
  onCancel,
}) => (
  <SectionRow>
    <Grid.Column span="2">
      <H4>
        <Trans>Additional Details</Trans>
      </H4>
    </Grid.Column>
    <Grid.Column key={`Column 'additional_details'`}>
      <FormGroup>
        <TextArea
          name="additional_details"
          label={labelFor(t`Additional Details`)}
          disabled={readOnly}
          maxLength={ADDITIONAL_DETAILS_MAX_LENGTH}
          value={additionalDetails || ''}
          onChange={(e) =>
            onAdditionalDetailsChange(normalizeTextValue(e.target.value))
          }
        />
      </FormGroup>
      {!readOnly && (
        <Flex marginTop={2}>
          <Button text={t`Save`} disabled={saveDisabled} onClick={onSave} />
          {canPropagate && (
            <Button
              style={{ marginLeft: '0.4rem' }}
              text={t`Save and Propagate`}
              icon={Share}
              kind="secondary"
              disabled={propagateDisabled}
              onClick={onSaveAndPropagate}
            />
          )}
          <Button
            style={{ marginLeft: '0.4rem' }}
            text={t`Cancel`}
            onClick={onCancel}
            kind="secondary"
          />
        </Flex>
      )}
    </Grid.Column>
  </SectionRow>
);

FormFooter.propTypes = {
  additionalDetails: PropTypes.string,
  onAdditionalDetailsChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  saveDisabled: PropTypes.bool,
  propagateDisabled: PropTypes.bool,
  canPropagate: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onSaveAndPropagate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
export default FormFooter;
